<template>
  <div>
    <Teleport to="#fast-contact-title">Contacter {{ $root.designerName }}</Teleport>
    <div class="py-8">
      <label for="title" class="text-body font-normal flex justify-between">
        <span>Votre message</span>
        <span>{{ 600 - store.form.content.length }}/600</span>
      </label>
      <FastInput
        v-model="store.form.content"
        type="textarea"
        :rows="10"
        :maxlength="600"
        name="content"
        :placeholder="`Saisissez votre message à destination de ${$root.designerName}`"
        @keydown.meta.enter="proceed()"
      />
    </div>
    <div class="mt-8 flex items-center">
      <div class="grow"></div>
      <vue-ladda
        :loading="loading"
        class="btn btn-primary py-4 px-8 md:ml-auto max-md:w-full"
        :disabled="!completed"
        @click="proceed()"
      >
        {{ isGuest ? 'Continuer' : 'Envoyer le message' }}&nbsp;
      </vue-ladda>
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, onMounted, ref } from 'vue'
import { useSendMessage } from '../composables/useSendMessage'
import { useMainStore } from '../stores/main'
import FastInput from '@/apps/shared/components/FastInput.vue'
const store = useMainStore()

const props = defineProps({
  isGuest: { type: Boolean, default: true }
})

const completed = computed(() => {
  return store.form.content.trim().split(' ').length >= 5
})

const emit = defineEmits(['goto'])
const sendMessage = useSendMessage(emit)
const loading = ref(false)
const proceed = async () => {
  if (props.isGuest) {
    emit('goto', 'userContact')
  } else {
    loading.value = true
    try {
      await sendMessage()
    } catch (error) {
      const quotaError = error?.body?.errors?.from_fast_contact
      if (quotaError && quotaError[0] === 'quota_exceeded') emit('goto', 'spam')
      else console.error(error)
    }
    loading.value = false
  }
}

onMounted(() => {
  // * Using autofocus attributes doesn't work here because the modal is not visible yet
  // * We have to wait for the end of the modal opening animation
  setTimeout(() => {
    document.querySelector('.fast-contact-modal .form-control').focus()
  }, 500)
})
</script>
